module.exports = __webpack_public_path__ + "static/media/id.8631c01c.png";